import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { ErrorsService, OAuthService } from 'common';
import { catchError, switchMap } from 'rxjs/operators';
import { BOAuthService } from '../services/boauth.service';

@Injectable({
  providedIn: 'root'
})
export class RefreshTokenInterceptor implements HttpInterceptor {

  constructor(private oauthService: OAuthService, private boAuthService: BOAuthService, private readonly errorsService: ErrorsService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.oauthService.authenticated) {
      return this.boAuthService.refreshAuthToken().pipe(
        switchMap((accessToken) => {
          if(accessToken) {
            return next.handle(request);
          }
          this.errorsService.showForbiddenErrorPage();
          return EMPTY;
        }),
        catchError(() => {
          this.errorsService.showForbiddenErrorPage();
          return EMPTY;
        }));
    } 
    else {
      this.oauthService.restartIdleTimer();
      return next.handle(request);
    }
  }
}
